import * as type from './actionTypesSagas';

export const loadAllStudyPrograms = () => ({
  type: type.GET_ALL_SP,
});
